import { useEffect } from 'react'
import { autorun } from 'mobx'

function useAutorun(fn, opts) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => autorun(fn, opts), [])
}

export default useAutorun
